<script setup lang="ts">
definePage({
  meta: {
    layout: 'landing-page',
    public: true,
  },
})
</script>

<template>
  <VContainer
    fluid
    class="py-8"
  >
    <!-- Hero Section -->
    <VCard
      class="mx-auto mb-6 about-hero-card pa-2 pa-md-8"
      image=""
    >
      <VCardText class="text-center">
        <div class="mb-4 d-flex flex-column align-center">
          <h1 class="mb-4 about-title">
            Sobre a Eventos Connect
          </h1>
          <p class="mb-6 about-subtitle text-h6">
            Conectando experiências, criando oportunidades
          </p>
        </div>
      </VCardText>
    </VCard>

    <!-- Main Content -->
    <VRow>
      <VCol cols="12">
        <VCard class="mb-6 about-content-card">
          <VCardText class="pa-6 pa-md-8">
            <div class="mb-8 about-section">
              <VIcon
                icon="tabler-link"
                size="48"
                class="mb-4 about-icon"
              />
              <h2 class="mb-4 section-title">
                Quem Somos
              </h2>
              <p class="section-text">
                A Eventos Connect é mais do que uma plataforma — somos um <strong>ecossistema inteligente de conexões estratégicas</strong> que transforma a maneira como eventos são planejados, organizados e realizados.
              </p>
            </div>

            <VDivider class="my-8" />

            <div class="mb-8 about-section">
              <VIcon
                icon="tabler-history"
                size="48"
                class="mb-4 about-icon"
              />
              <h2 class="mb-4 section-title">
                Nossa História
              </h2>
              <p class="section-text">
                Nascemos da união entre <strong>mais de duas décadas de experiência no mercado de eventos</strong> e o poder da tecnologia. Com isso, criamos um ambiente digital onde fornecedores de excelência e empresas contratantes se encontram, se conectam e fecham negócios com agilidade, confiança e profissionalismo.
              </p>
            </div>

            <VDivider class="my-8" />

            <div class="mb-8 about-section">
              <VIcon
                icon="tabler-target"
                size="48"
                class="mb-4 about-icon"
              />
              <h2 class="mb-4 section-title">
                Nossa Missão
              </h2>
              <p class="section-text">
                Nossa missão é <strong>impulsionar negócios, otimizar jornadas e valorizar experiências</strong>. Aqui, cada conexão é uma oportunidade real de crescimento, visibilidade e faturamento.
              </p>
            </div>

            <VDivider class="my-8" />

            <div class="about-section">
              <VIcon
                icon="tabler-spark"
                size="48"
                class="mb-4 about-icon"
              />
              <h2 class="mb-4 section-title">
                Nosso Compromisso
              </h2>
              <p class="section-text">
                <strong>Eventos corporativos de alto impacto começam aqui.</strong> Transformamos ideias em experiências memoráveis através de conexões estratégicas e tecnologia de ponta.
              </p>
            </div>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Features Section -->
    <VRow>
      <VCol cols="12">
        <VCard class="features-card">
          <VCardText class="pa-6 pa-md-8">
            <h2 class="mb-8 text-center features-title">
              Por que escolher a Eventos Connect?
            </h2>

            <VRow>
              <VCol
                cols="12"
                md="4"
                class="mb-4"
              >
                <div class="text-center feature-item">
                  <VIcon
                    icon="tabler-users"
                    size="64"
                    class="mb-4 feature-icon"
                  />
                  <h3 class="mb-3 feature-title">
                    Conexões Estratégicas
                  </h3>
                  <p class="feature-description">
                    Conectamos os melhores fornecedores com empresas que buscam excelência em eventos corporativos.
                  </p>
                </div>
              </VCol>

              <VCol
                cols="12"
                md="4"
                class="mb-4"
              >
                <div class="text-center feature-item">
                  <VIcon
                    icon="tabler-clock"
                    size="64"
                    class="mb-4 feature-icon"
                  />
                  <h3 class="mb-3 feature-title">
                    Agilidade e Eficiência
                  </h3>
                  <p class="feature-description">
                    Otimizamos processos para que você foque no que realmente importa: criar eventos excepcionais.
                  </p>
                </div>
              </VCol>

              <VCol
                cols="12"
                md="4"
                class="mb-4"
              >
                <div class="text-center feature-item">
                  <VIcon
                    icon="tabler-shield-check"
                    size="64"
                    class="mb-4 feature-icon"
                  />
                  <h3 class="mb-3 feature-title">
                    Confiança e Qualidade
                  </h3>
                  <p class="feature-description">
                    Todos os fornecedores são cuidadosamente selecionados para garantir a mais alta qualidade de serviço.
                  </p>
                </div>
              </VCol>
            </VRow>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<style scoped>
.about-hero-card {
  border: 1px solid rgba(255, 255, 255, 20%);
  border-radius: 24px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 10%) 0%, rgba(99, 102, 241, 10%) 100%);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 15%);
}

.about-content-card,
.features-card {
  border: 1px solid rgba(255, 255, 255, 20%);
  border-radius: 24px;
  background: rgba(255, 255, 255, 95%);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 15%);
}

.about-title {
  background: linear-gradient(90deg, #3b82f6 0%, #2BB6FC 100%);
  background-clip: text;
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
  -webkit-text-fill-color: transparent;
}

.about-subtitle {
  font-style: italic;
  font-weight: 500;
}

.about-section {
  position: relative;
  animation: fade-in-up 0.6s ease-out;
  padding-block: 1.5rem;
  padding-inline: 0;
}

.about-icon {
  color: #3b82f6;
  margin-block-end: 1rem;
}

.section-title {
  background: linear-gradient(90deg, #3b82f6 0%, #2BB6FC 100%);
  background-clip: text;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.3;
  margin-block-end: 1rem;
  -webkit-text-fill-color: transparent;
}

.section-text {
  color: #475569;
  font-size: 1.1rem;
  line-height: 1.7;
  text-align: justify;
}

.features-title {
  background: linear-gradient(90deg, #3b82f6 0%, #2BB6FC 100%);
  background-clip: text;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.3;
  -webkit-text-fill-color: transparent;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  block-size: 100%;
  padding-block: 2rem;
  padding-inline: 1rem;
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
}

.feature-icon {
  color: #3b82f6;
  margin-block-end: 1rem;
}

.feature-title {
  color: #1e293b;
  font-size: 1.25rem;
  font-weight: 600;
  margin-block-end: 1rem;
}

.feature-description {
  color: #64748b;
  font-size: 1rem;
  line-height: 1.6;
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .about-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .features-title {
    font-size: 1.75rem;
  }

  .feature-item {
    padding-block: 1.5rem;
    padding-inline: 0.5rem;
  }
}

/* Animation for smooth scrolling */
@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
